module.exports = __webpack_public_path__ + "static/media/sleepnix-1.7fadd3a3.jpg";